module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.zipcode) ? _c('div', {
    staticClass: "MapPopup"
  }, [_c('p', {
    staticClass: "MapPopup-zip"
  }, [_vm._v("Zip Code: " + _vm._s(_vm.zipcode))]), _vm._v(" "), (_vm.distance) ? _c('div', [_vm._v(_vm._s(_vm.distance) + " miles away")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "MapPopup-details"
  }, _vm._l((_vm.squads), function(squad, index) {
    return _c('li', {
      key: squad.id,
      staticClass: "u-mt2"
    }, [_c('p', {
      staticClass: "u-mb1"
    }, [_vm._v("\n        " + _vm._s(squad.name)), _c('br'), _vm._v("\n        District: " + _vm._s(squad.district_name)), _c('br'), _vm._v("\n        Squad Leader: " + _vm._s(squad.firstName) + " " + _vm._s(squad.lastName)), _c('br'), _vm._v(" "), (squad.website) ? _c('span', [_vm._v("\n          Website: " + _vm._s(squad.website) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "Button Button--outline Button--small",
      on: {
        "click": function($event) {
          _vm.joinSquad(squad)
        }
      }
    }, [_vm._v("Join This Squad")])])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38f1e15a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/map-popup-squad.vue
// module id = 328
// module chunks = 0